// src/pages/FaqPage.jsx
//
// PUBLIC /faq page (home-packfinder). The same items as the home page's FAQ section
// (resolveFaq over Site Text), on a URL of their own so they can be linked, shared and
// crawled. scripts/prerender.mjs bakes the SAME items into dist/faq/index.html together
// with FAQPage structured data; this component is what replaces that static HTML once
// the app mounts.
//
// If Danielle switches the FAQ off (or empties it) the page says so and points back to
// the packs. It deliberately does NOT redirect: on a hard load the first render sees
// cached or default Site Text and the live doc lands a moment later, so a redirect here
// could bounce a visitor off a page that is about to have content. The prerender step
// drops /faq from the build and the sitemap in the same condition.
import React from 'react';
import { usePageSeo } from '../components/usePageSeo.js';
import { useNavigate } from 'react-router-dom';
import FaqList from '../components/home/FaqList.jsx';
import { resolveFaq } from '../components/home/faq.js';

export default function FaqPage({ state }) {
    const navigate = useNavigate();
    const faq = resolveFaq(state && state.siteText);

    usePageSeo(state?.siteText, 'faq');

    return (
        <div className="page-fade-in min-h-[calc(100vh-4rem)] bg-book-bg">
            <main className="max-w-3xl mx-auto px-4 md:px-8 py-10 md:py-16">
                <div className="mb-8">
                    <h1 className="font-display text-book-text text-3xl md:text-4xl font-bold leading-tight">{faq.heading}</h1>
                    <div className="h-px bg-book-line mt-4" />
                </div>

                {faq.visible
                    ? <FaqList items={faq.items} idPrefix="faqpage" headingLevel={2} />
                    : <p className="font-serif italic text-book-muted text-base">There are no questions here at the moment.</p>}

                <div className="mt-10 flex flex-wrap items-center gap-x-5 gap-y-3">
                    <button type="button" onClick={() => navigate('/home')}
                        className="px-5 py-2.5 rounded-full bg-book-accent text-book-pageDark font-display text-sm font-semibold hover:bg-book-accentLight transition-colors">
                        See the study packs
                    </button>
                </div>
            </main>
        </div>
    );
}
